import { gql } from '@apollo/client'

export const StartProjectBulkAdd = gql`
    mutation startProjectBulkAdd($input: StartProjectBulkAddInput!) {
        projectBulkAdd(input: $input) {
            instanceId
        }
    }
`
